import { Component } from "@angular/core";
import { PonderAuthClient } from "@apiserver-rest/ponder-auth-client";
import { AuthResponse, UserRoleAndPermissions } from "@apiserver-rest/ponder-auth-client-base";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { Subscription, take } from "rxjs";

@Component({
    selector: "undelete-user-dialog",
    imports: [BusySpinComponent],
    templateUrl: "./undelete-user-dialog.component.html"
})
export class UndeleteUserDialogComponent {
    public isVisible: boolean = false;
    public user?: UserRoleAndPermissions;
    public isRunning: boolean = false;
    public undeleteFailed: boolean = false;
    
    public readonly closeSvgIcon: string = SvgIconMap.get(SvgIcon.Close)!;

    private undeleteUserSub!: Subscription;

    public constructor(private ponderAuthclient: PonderAuthClient, private events: EventBroker) {
        this.undeleteUserSub = this.events.admin.undeleteUserEvent.subscribe({
            next: (user: UserRoleAndPermissions) => {
                this.onOpen(user);
            }
        });
    }

    public ngOnDestroy(): void {
        this.undeleteUserSub.unsubscribe();
    }
    
    private onOpen(user: UserRoleAndPermissions) {
        this.user = user;
        this.isVisible = true;
    }

    public onClose(): void {
        this.user = undefined;
        this.isVisible = false;
        this.undeleteFailed = false;
    }

    public onConfirm(): void {
        if (this.isRunning || !this.user) {
            return;
        }

        this.isRunning = true;
        this.undeleteFailed = false;

        this.ponderAuthclient
            .accountRestore(this.user.user.username)
            .pipe(take(1))
            .subscribe({
                next: (response: AuthResponse) => {
                    if (response.success) {
                        this.onClose();
                    } else {
                        this.undeleteFailed = true;
                    }
                },
                error: () => {
                    this.undeleteFailed = true;
                }
            })
            .add(() => { this.isRunning = false; });
    }
}